import styled from "styled-components";
import { Icon } from "../../../../../services/visualLibraryService";

export const IconStyled = styled(Icon)`
  width: ${props => props.iconWidth || props.theme.components.selector.icon.size};
  height: ${props => props.iconHeight || props.theme.components.selector.icon.size};
  fill: ${props => props.theme.color.white};
  transform: ${props => props.theme.locale.dir === "rtl" && "rotate(180deg)"};
`;

export const SelectorStyled = styled.ul`
  text-align: ${props => (props.theme.locale.dir === "rtl" ? "right" : "left")};
`;

export const SelectorItemTab = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${props => (props.description ? "0.5rem" : "0.84rem")} 1.263rem;
  box-sizing: border-box;
  border-radius: 0.5rem;
  background: ${props => props.theme.components.selector.background.default};
  margin-bottom: 1rem;
  color: ${props => props.theme.components.selector.color.default || props.theme.color.primary};
  cursor: ${props => (props.disabled ? "not-allowed" : "pointer")};
  ${props => props.disabled && `opacity: 0.6`};
  &.focused {
    border: 0.125rem solid ${props => props.theme.components.selector.border.focused || props.theme.color.primary};
    background-color: ${props => props.theme.components.selector.background.focused || props.theme.color.primary};
    color: ${props => props.theme.components.selector.color.focused || props.theme.color.secondary};
    ${IconStyled} {
      fill: ${props => props.theme.color.greyBlack};
    }
    font-weight: ${props => props.theme.font.weight.semiBold};
  }
`;

export const SelectorTitleStyled = styled.div`
  font-size: ${props => props.theme.font.size.default};
  font-weight: ${props => props.theme.font.weight.default};
  line-height: 2.25rem;
  direction: ${props => (props.theme.locale.dir === "rtl" ? "ltr" : "ltr")};
`;

export const DescriptionStyled = styled.div`
 ${props => !props.focused && `opacity:${props.theme.opacity.default}`}
  color: ${props => props.theme.color[props.focused ? "black" : "greyLight"]};
  font-size: ${props => props.theme.font.size.small};
  line-height: 2.5rem;

  &.focused {
    color: ${props => props.theme.color.black};
  }
`;

export const InfoWrapper = styled.div`
  text-align: ${props => (props.theme.locale.dir === "rtl" ? "right" : "left")};
  width: 94%;
`;
